import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { AuthService } from '../services/auth-service';

export type RoleId = 1 | 2 | 3;

function getRoleId(): RoleId | null {
  const raw = localStorage.getItem('roleId') ?? sessionStorage.getItem('roleId');
  if (!raw) return null;

  const n = Number(raw);
  if (n === 1 || n === 2 || n === 3) return n as RoleId;

  return null;
}

export function roleGuard(allowedRoleIds: RoleId[]): CanActivateFn {
  return (): boolean | UrlTree => {
    const router = inject(Router);

    const roleId = getRoleId();

    // ✅ اگر roleId نداریم، اجازه نده (این مهمه)
    if (roleId === null) {
      return router.parseUrl('/auth/login');
    }

    if (!allowedRoleIds.includes(roleId)) {
      return router.parseUrl('/notfound');
    }

    return true;
  };
}

// صفحه‌ی شروع پرسنلی که دسترسی داشبورد ندارند
const STAFF_HOME: [string, string][] = [
  ['reservations.view', '/room-availability'],
  ['reservations.create', '/reservations/new'],
  ['customers.view', '/customers'],
  ['rooms.manage', '/rooms'],
  ['pricing.manage', '/pricing'],
  ['blocks.manage', '/booking-blocks'],
  ['payments.links', '/payment-links'],
  ['payments.manage', '/reservations'],
  ['payments.report', '/payments-management'],
  ['sms.view', '/sms'],
  ['sms.settings', '/sms'],
  ['payments.settings', '/payments-management'],
  ['logs.view', '/logs'],
  ['settings.manage', '/settings'],
  ['appearance.manage', '/appearance'],
];
// بدون هیچ دسترسی صفحه‌ای: راهنما و هشدارها همیشه در دسترس است
const FALLBACK_HOME = '/help';

export const dashboardGuard: CanActivateFn = (): boolean | UrlTree => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.getRoleId() === null) return router.parseUrl('/auth/login');
  if (auth.can('dashboard.view')) return true;
  const home = STAFF_HOME.find(([permission]) => auth.can(permission));
  return router.parseUrl(home ? home[1] : FALLBACK_HOME);
};

// مدیر همه‌جا؛ پرسنل فقط با یکی از دسترسی‌های داده‌شده. 'admin' = فقط مدیر سامانه
export function accessGuard(...permissions: string[]): CanActivateFn {
  return (): boolean | UrlTree => {
    const auth = inject(AuthService);
    const router = inject(Router);
    if (auth.getRoleId() === null) return router.parseUrl('/auth/login');
    if (permissions.includes('admin')) return auth.isAdmin() ? true : router.parseUrl('/auth/access');
    return auth.can(...permissions) ? true : router.parseUrl('/auth/access');
  };
}
